/* global x5script */

import $ from 'jquery';

class Growth {
  constructor() {
    this.selectors = {
      button: '.js-growth-description-more-button',
    };

    this.button = $(this.selectors.button);

    if (!this.button.length) {
      return;
    }

    this.classes = {
      open: 'is-open',
    };

    this.readMoreLess = x5script.readMoreLess;

    this.toggleDescription();
  }

  toggleDescription() {
    this.button.on('click', e => {
      const button = $(e.currentTarget);
      const div = button.parent();
      const description = div.find('p');

      if (description.length) {
        if (div.hasClass(this.classes.open)) {
          description.slideUp(300, () => {
            div.removeClass(this.classes.open);
            button.text(this.readMoreLess.more);
          });
        } else {
          description.slideDown(300, () => {
            div.addClass(this.classes.open);
            button.text(this.readMoreLess.less);
          });
        }
      }
    });
  }
}

export default new Growth();



// WEBPACK FOOTER //
// ./src/scripts/modules/growth.js